var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-0"},[_c('v-card-text',[_c('ManualUnmatched',{attrs:{"item":_vm.item,"type":_vm.type}}),_c('v-divider',{staticClass:"my-12"}),_c('ManualMatched',{attrs:{"item":_vm.item,"type":_vm.type}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }